/**
 * 型定義を保ったオブジェクトのキーと値の配列を返す
 * @param obj 任意のオブジェクト
 * @returns 型定義を保ったオブジェクトのキーと値の配列
 */
export const strictObjectEntries = <
  T extends Record<string | number, any>,
  U extends keyof T extends string
    ? keyof T
    : keyof T extends number
      ? keyof T
      : never,
>(
  obj: T,
): [`${U}`, T[U]][] => Object.entries(obj) as [`${U}`, T[U]][]

/**
 * オブジェクト/配列のディープコピーを作成する
 * @param obj 任意のオブジェクト/配列
 */
export const deepCopy = <T>(obj: T): T => JSON.parse(JSON.stringify(obj))

/**
 * Typed `Object.keys` for const Object
 * @param obj
 */
export const objectKeys = <T extends object>(obj: T) => Object.keys(obj) as (keyof T)[]
export const objectNumberKeys = <T extends Record<number, any>>(obj: T) => Object.keys(obj).map(Number) as ((keyof T) extends infer Num extends number ? Num : never)[]

/**
 * Typed `Object.values` for const Object
 * @param obj
 */
export const objectValues = <T extends Record<number, any>>(obj: T) => Object.values(obj) as T[keyof T][]

/**
 * Util for omitting undefined values from object
 * @param obj
 * メモ: 現状は Partial と Required での簡易的な実装のみ
 */
export const objectOmitUndefined = <T extends Record<string, any>>(obj: T): Partial<Required<T>> => {
  const result = {} as Partial<T>
  for (const key in obj) {
    if (obj[key] !== undefined) {
      result[key] = obj[key]
    }
  }
  return result
}
